import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import SimpleNavBar from '../nav/SimpleNavBar';

import Header1 from '../../static/img/nia_day_guide_page/NiaDayGuideHeader2.png';
import Header2 from '../../static/img/nia_day_guide_page/NiaDayGuideHeader1.png';
import FeelBetterText from '../../static/img/nia_day_guide_page/FeelBetterText.png';
import AboutNiaText from '../../static/img/nia_day_guide_page/AboutNiaText.png';

import GlamourLogo from '../../static/img/nia_day_guide_page/glamour_logo.png';
import HuffpostLogo from '../../static/img/nia_day_guide_page/huffpost_logo.png';
import NewyorktimesLogo from '../../static/img/nia_day_guide_page/newyorktimes_logo.png';
import PeopleLogo from '../../static/img/nia_day_guide_page/people_logo.png';
import PsychologytodayLogo from '../../static/img/nia_day_guide_page/pyschologytoday_logo.png';
import SelfLogo from '../../static/img/nia_day_guide_page/self_logo.png';
import WashingtonpostLogo from '../../static/img/nia_day_guide_page/washingtonpost_logo.png';


const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  container: {
    width: 'auto',
    // marginLeft: theme.spacing(2),
    // marginRight: theme.spacing(2),
    [theme.breakpoints.up(1200)]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  header: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    fontSize: '32px',
    letterSpacing: '0.1em',
    fontWeight: 'bold',
  },
  headerContent: {
    padding: theme.spacing(3),
    [theme.breakpoints.down(960)]: {
      marginLeft: theme.spacing(6),
      marginRight: theme.spacing(6),
    },
    [theme.breakpoints.down(600)]: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
    },
  },
  headerImg: {
    height: '200px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down(600)]: {
      height: '150px',
    },
  },
  headerImg1: {
    backgroundImage: `url(${Header1})`,
  },
  headerImg2: {
    backgroundImage: `url(${Header2})`,
  },
  red: {
    color: '#f63c57',
  },
  white: {
    color: 'white',
  },
  formHeader: {
    fontSize: '32px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  form: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up(900)]: {
      maxHeight: '300px',
    },
  },
  formContainer: {
    backgroundColor: '#00c2cb',
    borderRadius: '20px',
    top: '-50px',
    padding: theme.spacing(4),
    position: 'relative',
    [theme.breakpoints.up(900)]: {
    },
  },
  formSubtext: {
    fontSize: '12px',
    textAlign: 'center',
    marginBottom: theme.spacing(),
    paddingTop: theme.spacing(2),
  },
  link: {
    fontWeight: 'bold',
    textDecoration: 'none',
    color: 'white',
    '&visited': {
      textDecoration: 'none',
      color: 'white',
    },
  },
  bulletPoints: {
    fontSize: '22px',
  },
  aboutNiaSection: {
    // backgroundColor: '#E5E5E5',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(),
  },
  aboutNiaFlex: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  aboutNiaImg: {
    [theme.breakpoints.down(600)]: {
      width: '60%',
    },
    width: '40%',
  },
  aboutNiaText: {
    fontSize: '20px',
    fontFamily: 'Montserrat',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  feelBetterText: {
    width: '100%',
  },
  aboutNiaTextContainer: {
    paddingTop: theme.spacing(3),
  },
  asSeenInSection: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  asSeenInText: {
    textAlign: 'center',
    fontSize: '22px',
    fontWeight: '500',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),
  },
  asSeenInLogo: {
    margin: theme.spacing(2),
    height: '30px',
    width: 'auto',
    [theme.breakpoints.down(900)]: {
      height: '20px',
    },
  },
  asSeenInContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: '90%',
  },
  formSection: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  infusionForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  horizontalFields: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  infusionFieldInput: {
    margin: theme.spacing(1),
    backgroundColor: 'white',
  },
  button: {
    color: 'white',
    backgroundColor: '#f63c57',
    '&:hover': {
      backgroundColor: '#f52443',
    },
    '&:disabled': {
      backgroundColor: '#f86d82',
      color: 'white',
    },
    fontSize: '24px',
  },
  videoSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  video: {
    width: '426px',
    height: '225px',
    [theme.breakpoints.up(1200)]: {
      width: '520px',
      height: '292px',
    },
    [theme.breakpoints.down(600)]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
});

class NiaDayGuidePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inf_field_FirstName: '',
      inf_field_Email: '',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const {
      classes,
    } = this.props;
    const {
      inf_field_FirstName,
      inf_field_Email,
    } = this.state;
    function canSubmit() {
      if (inf_field_FirstName !== '' && inf_field_Email !== '') {
        return true;
      }
      return false;
    }
    return (
      <div className={classes.page}>
        <SimpleNavBar />
        <main className={classes.container}>
          <div className={classes.appBarSpacer} />
          <div className={classes.content}>
            <Grid container>
              {/* Header Section */}
              <Grid item xs={12} className={classNames(classes.headerImg, classes.headerImg2)} />
              <Grid item xs={12} md={4} className={classNames(classes.form, classes.white)}>
                <div className={classes.formContainer}>
                  {/* Form Section */}
                  <Typography className={classes.formHeader}>
                    Get your&nbsp;
                    <span className={classes.uppercase}>free</span>
                    <br />
                    &nbsp;&apos;Nia Day&apos; Guide
                  </Typography>
                  <form acceptCharset="UTF-8" action="https://sp877.infusionsoft.com/app/form/process/a0a8138a92ba7e33fec4ab7c51d5389f" className={classes.infusionForm} id="inf_form_a0a8138a92ba7e33fec4ab7c51d5389f" method="POST">
                    <input name="inf_form_xid" type="hidden" value="a0a8138a92ba7e33fec4ab7c51d5389f" />
                    <input name="inf_form_name" type="hidden" value="Nia Day PDF Request~br~Web Form Submitted" />
                    <input name="infusionsoft_version" type="hidden" value="1.70.0.426972" />
                    <div className={classes.horizontalFields}>
                      <TextField
                        required
                        className={classes.infusionFieldInput}
                        id="inf_field_FirstName"
                        name="inf_field_FirstName"
                        placeholder="First Name *"
                        type="text"
                        variant="outlined"
                        value={inf_field_FirstName}
                        onChange={this.handleChange}
                        inputProps={{ style: { fontSize: '18px' } }}
                      />
                      <TextField
                        required
                        className={classes.infusionFieldInput}
                        id="inf_field_Email"
                        name="inf_field_Email"
                        placeholder="Email *"
                        type="text"
                        variant="outlined"
                        value={inf_field_Email}
                        onChange={this.handleChange}
                        inputProps={{ style: { fontSize: '18px' } }}
                      />
                    </div>
                    <Button disabled={!canSubmit()} color="secondary" variant="outlined" size="large" className={classNames(classes.button, 'infusion-recaptcha')} id="recaptcha_a0a8138a92ba7e33fec4ab7c51d5389f" type="submit">SUBMIT</Button>
                  </form>
                  <script type="text/javascript" src="https://sp877.infusionsoft.app/app/webTracking/getTrackingCode" />
                  <script type="text/javascript" src="https://sp877.infusionsoft.com/resources/external/recaptcha/production/recaptcha.js?b=1.70.0.426972-hf-202201191855" />
                  <script src="https://www.google.com/recaptcha/api.js?onload=onloadInfusionRecaptchaCallback&render=explicit" async="async" defer="defer" />
                  <script type="text/javascript" src="https://sp877.infusionsoft.com/app/timezone/timezoneInputJs?xid=a0a8138a92ba7e33fec4ab7c51d5389f" />
                  <Typography className={classes.formSubtext}>
                    By signing up your agree to Nia&apos;s&nbsp;
                    <a className={classes.link} href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                    &nbsp;and&nbsp;
                    <a className={classes.link} href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    &nbsp;and opt-in to receive email communications from Nia
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={8} className={classes.headerContent}>
                <Typography variant="h1" className={classNames(classes.header, classes.uppercase)}>
                  Get your&nbsp;
                  <span className={classes.red}>free checklist + guide</span>
                </Typography>
                <ul className={classes.bulletPoints}>
                  <li>
                    <p>
                      <strong>8 simple steps </strong>
                      to feel better body, mind + spirit
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>Tips to make movement and mindfulness </strong>
                      a part of your daily routine
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>Easy-to-follow checklist </strong>
                      to help you build new healthy habits
                    </p>
                  </li>
                </ul>
                <img src={FeelBetterText} className={classes.feelBetterText} alt="the words feel better in cursive" />
              </Grid>
              <Grid item xs={12} className={classNames(classes.headerImg, classes.headerImg1)} />
              {/* As Seen In Section */}
              <Grid item xs={12} className={classes.asSeenInSection}>
                <Typography className={classes.asSeenInText}>As Seen In</Typography>
                <div className={classes.asSeenInContainer}>
                  <img src={GlamourLogo} alt="glamour logo" className={classes.asSeenInLogo} />
  {/*                <img src={} alt="health logo" className={classes.asSeenInLogo} />*/}                
                  <img src={HuffpostLogo} alt="huffpost logo" className={classes.asSeenInLogo} />
                  <img src={PeopleLogo} alt="people logo" className={classes.asSeenInLogo} />
                  <img src={SelfLogo} alt="self logo" className={classes.asSeenInLogo} />
                  <img src={NewyorktimesLogo} alt="the new york times logo" className={classes.asSeenInLogo} />
                  <img src={PsychologytodayLogo} alt="psychology today logo" className={classes.asSeenInLogo} />
                  <img src={WashingtonpostLogo} alt="washington post logo" className={classes.asSeenInLogo} />
                </div>
              </Grid>
              {/* About Nia Section */}
              <Grid item xs={12} md={6} className={classes.aboutNiaSection}>
                <img src={AboutNiaText} alt="the words about nia in cursive" className={classes.aboutNiaImg} />
                <div className={classes.aboutNiaFlex}>
                  <div className={classes.aboutNiaTextContainer}>
                    <Typography className={classes.aboutNiaText}>Blending movement, mindfulness, connection and joy, Nia® is an experience, practice and lifestyle that integrates body, mind and spirit to help people from all walks of life live happier, healthier lives.</Typography>
                    <Typography className={classes.aboutNiaText}>Fusing ancient wisdom and modern science with elements of dance, martial arts, healing arts, meditation and mindfulness, Nia offers physical, mental and emotional conditioning, healing and transformation that is accessible and attainable for every body.</Typography>
                  </div>
                </div>
              </Grid>
              {/* Video Section */}
              <Grid item xs={12} md={6} className={classes.videoSection}>
                <iframe
                  title="What is Nia?"
                  src="https://www.youtube.com/embed/U3rRjq1oaXg"
                  className={classes.video}
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                />
              </Grid>
            </Grid>
          </div>
        </main>
      </div>
    );
  }
}

NiaDayGuidePage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NiaDayGuidePage);
